export default "__VITE_ASSET__DeApOON5__"